import type { IconData } from '@stacksjs/iconify-core'

export const chartPie: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 12V2c5.523 0 10 4.477 10 10z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"m12 12l5 8.66A10.01 10.01 0 0 0 22 12z\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M17 20.66L12 12V2c-5.523.002-9.999 4.48-9.997 10.003S6.483 22.002 12.007 22A10 10 0 0 0 17 20.662l.003-.005l-.004.003z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chartPie
